export const ECOSYSTEM_PROFILES = [
  // 1. TROPICAL CORAL REEF (10 species)
  {
    id: 'tropical-reef',
    name: 'Tropical Reef',
    description: 'Vibrant coral ecosystem with diverse fish species',
    image: '/images/ecosystems/tropical.jpg',
    params: {
      temperature: 26.5,
      salinity: 35,
      ph: 8.2,
      oxygen: 6.5, 
      co2: 400,
      orp: 300,
      flowRate: 1.2,
      lightIntensity: 75
    },
    organisms: [
      {
        name: 'Acropora Coral',
        image: '/images/organisms/acropora.jpg',
        idealParams: {
          temperature: { min: 24, max: 28, unit: '°C' },
          lightIntensity: { min: 70, max: 90, unit: '%' },
          flowRate: { min: 1, max: 3, unit: 'cm/s' }
        }
      },
      {
        name: 'Parrotfish',
        image: '/images/organisms/parrotfish.jpg',
        idealParams: {
          temperature: { min: 25, max: 29, unit: '°C' },
          oxygen: { min: 5.5, max: 8, unit: 'mg/L' }
        }
      },
      {
        name: 'Mandarin Dragonet',
        image: '/images/organisms/mandarin.jpg',
        idealParams: {
          temperature: { min: 24, max: 27, unit: '°C' },
          salinity: { min: 32, max: 35, unit: 'ppt' }
        }
      },
      {
        name: 'Hammer Coral',
        image: '/images/organisms/hammer-coral.jpg',
        idealParams: {
          temperature: { min: 23, max: 27, unit: '°C' },
          lightIntensity: { min: 50, max: 80, unit: '%' }
        }
      },
      {
        name: 'Blue Tang',
        image: '/images/organisms/blue-tang.jpg',
        idealParams: {
          temperature: { min: 24, max: 28, unit: '°C' },
          flowRate: { min: 0.5, max: 2, unit: 'cm/s' }
        }
      },
      {
        name: 'Bubble Tip Anemone',
        image: '/images/organisms/bta.jpg',
        idealParams: {
          temperature: { min: 22, max: 28, unit: '°C' },
          lightIntensity: { min: 60, max: 85, unit: '%' }
        }
      },
      {
        name: 'Copperband Butterflyfish',
        image: '/images/organisms/copperband.jpg',
        idealParams: {
          temperature: { min: 25, max: 28, unit: '°C' },
          ph: { min: 8.0, max: 8.4, unit: '' }
        }
      },
      {
        name: 'Duncan Coral',
        image: '/images/organisms/duncan.jpg',
        idealParams: {
          temperature: { min: 23, max: 27, unit: '°C' },
          flowRate: { min: 0.5, max: 1.5, unit: 'cm/s' }
        }
      },
      {
        name: 'Firefish Goby',
        image: '/images/organisms/firefish.jpg',
        idealParams: {
          temperature: { min: 24, max: 27, unit: '°C' },
          oxygen: { min: 6, max: 8, unit: 'mg/L' }
        }
      },
      {
        name: 'Zoanthids',
        image: '/images/organisms/zoas.jpg',
        idealParams: {
          temperature: { min: 22, max: 28, unit: '°C' },
          lightIntensity: { min: 40, max: 70, unit: '%' }
        }
      },

      // Add to your ECOSYSTEM_PROFILES array
{
  id: 'seahorse-habitat',
  name: 'Seahorse Habitat',
  description: 'Specialized tank for seahorses with controlled feeding',
  image: '/images/ecosystems/seahorse-tank.jpg',
  params: {
    temperature: 25.5,
    salinity: 34,
    flowRate: 0.2,
    foodAmount: 0.2,
    feedingFrequency: 3,
    liveFood: true
  },
  organisms: [
    {
      name: 'Lined Seahorse',
      image: '/images/organisms/seahorse-lined.jpg',
      idealParams: {
        temperature: { min: 24, max: 28, unit: '°C' },
        flowRate: { min: 0.1, max: 0.5, unit: 'cm/s' },
        foodAmount: { min: 0.1, max: 0.3, unit: 'g/feeding' },
        feedingFrequency: { min: 2, max: 4, unit: 'times/day' },
        liveFood: { required: true }
      }
    }
  ]
}


    ]
  },

  // 2. COLD WATER MARINE (5 species)
  {
    id: 'cold-water',
    name: 'Cold Water',
    description: 'Temperate marine ecosystem with unique species',
    image: '/images/ecosystems/cold_water.jpg',
    params: {
      temperature: 15.0,
      salinity: 34,
      ph: 8.0,
      oxygen: 7.0,
      co2: 450,
      orp: 320,
      flowRate: 0.5,
      lightIntensity: 40
    },
    organisms: [
      {
        name: 'Giant Kelp',
        image: '/images/organisms/kelp.jpg',
        idealParams: {
          temperature: { min: 10, max: 18, unit: '°C' },
          lightIntensity: { min: 30, max: 60, unit: '%' }
        }
      },
      {
        name: 'Wolf Eel',
        image: '/images/organisms/wolf-eel.jpg',
        idealParams: {
          temperature: { min: 12, max: 16, unit: '°C' },
          oxygen: { min: 6, max: 8, unit: 'mg/L' }
        }
      },
      {
        name: 'Sea Urchin',
        image: '/images/organisms/urchin.jpg',
        idealParams: {
          temperature: { min: 10, max: 18, unit: '°C' },
          ph: { min: 7.8, max: 8.3, unit: '' }
        }
      },
      {
        name: 'Rockfish',
        image: '/images/organisms/rockfish.jpg',
        idealParams: {
          temperature: { min: 8, max: 16, unit: '°C' },
          salinity: { min: 32, max: 35, unit: 'ppt' }
        }
      },
      {
        name: 'Sea Anemone (Cold)',
        image: '/images/organisms/cold-anemone.jpg',
        idealParams: {
          temperature: { min: 10, max: 17, unit: '°C' },
          flowRate: { min: 0.3, max: 1, unit: 'cm/s' }
        }
      }
    ]
  },

  // 3. DEEP SEA (5 species)
  {
    id: 'deep-sea',
    name: 'Deep Sea',
    description: 'Mysterious deep ocean environment',
    image: '/images/ecosystems/deep.jpeg',
    params: {
      temperature: 4.0,
      salinity: 35,
      ph: 7.8,
      oxygen: 2.0,
      co2: 800,
      orp: -100,
      pressure: 150,
      lightIntensity: 5
    },
    organisms: [
      {
        name: 'Anglerfish',
        image: '/images/organisms/anglerfish.jpg',
        idealParams: {
          temperature: { min: 2, max: 6, unit: '°C' },
          pressure: { min: 100, max: 200, unit: 'atm' }
        }
      },
      {
        name: 'Vampire Squid',
        image: '/images/organisms/vampire-squid.jpg',
        idealParams: {
          temperature: { min: 3, max: 7, unit: '°C' },
          oxygen: { min: 1, max: 3, unit: 'mg/L' }
        }
      },
      {
        name: 'Giant Isopod',
        image: '/images/organisms/isopod.jpg',
        idealParams: {
          temperature: { min: 2, max: 8, unit: '°C' },
          pressure: { min: 80, max: 180, unit: 'atm' }
        }
      },
      {
        name: 'Sixgill Shark',
        image: '/images/organisms/sixgill.jpg',
        idealParams: {
          temperature: { min: 4, max: 10, unit: '°C' },
          salinity: { min: 34, max: 36, unit: 'ppt' }
        }
      },
      {
        name: 'Bioluminescent Jelly',
        image: '/images/organisms/bio-jelly.jpg',
        idealParams: {
          temperature: { min: 3, max: 7, unit: '°C' },
          lightIntensity: { min: 0, max: 10, unit: '%' }
        }
      }
    ]
  },

  // 4. MANGROVE (5 species)
  {
    id: 'mangrove',
    name: 'Mangrove',
    description: 'Coastal brackish water ecosystem',
    image: '/images/ecosystems/mangrove.jpg',
    params: {
      temperature: 28.0,
      salinity: 25,
      ph: 7.9,
      oxygen: 5.5,
      co2: 500,
      orp: 250,
      flowRate: 0.3,
      lightIntensity: 60
    },
    organisms: [
      {
        name: 'Mangrove Snapper',
        image: '/images/organisms/mangrove-snapper.jpg',
        idealParams: {
          temperature: { min: 25, max: 30, unit: '°C' },
          salinity: { min: 20, max: 30, unit: 'ppt' }
        }
      },
      {
        name: 'Archerfish',
        image: '/images/organisms/archerfish.jpg',
        idealParams: {
          temperature: { min: 26, max: 31, unit: '°C' },
          ph: { min: 7.5, max: 8.2, unit: '' }
        }
      },
      {
        name: 'Fiddler Crab',
        image: '/images/organisms/fiddler-crab.jpg',
        idealParams: {
          temperature: { min: 25, max: 32, unit: '°C' },
          salinity: { min: 15, max: 28, unit: 'ppt' }
        }
      },
      {
        name: 'Mudskipper',
        image: '/images/organisms/mudskipper.jpg',
        idealParams: {
          temperature: { min: 26, max: 32, unit: '°C' },
          oxygen: { min: 4, max: 7, unit: 'mg/L' }
        }
      },
      {
        name: 'Mangrove Jack',
        image: '/images/organisms/mangrove-jack.jpg',
        idealParams: {
          temperature: { min: 24, max: 30, unit: '°C' },
          flowRate: { min: 0.1, max: 0.5, unit: 'cm/s' }
        }
      }
    ]
  }

  
];